import generateTypes from '../utils/generateTypes';

export const GET_SESSIONS = generateTypes('GET_SESSIONS');
export const RESET_SESSIONS = 'RESET_SESSIONS';
export const SET_TARGET_AUDIENCE_REACH = 'SET_TARGET_AUDIENCE_REACH';
